import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://nvorbvqhgilbpvtuacbl.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_fWQe-OJDH8igfLZNdSd4lQ_zfehFAwN";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
